import React from 'react';

const ServiceProvidersList = React.memo(() => {
  return (
    <>
      <ul>
        <li>
          A verified <strong>ID.me</strong> account, <strong>or</strong>
        </li>
        <li>
          A verified <strong>Login.gov</strong> account, <strong>or</strong>
        </li>
        <li>
          A verified{' '}
          <strong>
            <span aria-label="Clear">CLEAR</span>
          </strong>{' '}
          account
        </li>
      </ul>
      <p>
        If you don’t have one of these accounts, you can create a free{' '}
        <strong>ID.me</strong>, <strong>Login.gov</strong>, or{' '}
        <strong>
          <span aria-label="Clear">CLEAR</span>
        </strong>{' '}
        account.
      </p>
    </>
  );
});

export default ServiceProvidersList;
